import { useIntegratedForm } from '../../../../forms/use-integrated-form';
import { useBoloPanelMetadata } from '../../../../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { AttributeOption, BoloPanelFormType, DispatchAreaOption } from '@mark43/cad-api';
import { VStack, DataList, DataItem } from '@cad-arc';
import { SectionTitle } from '../../../../fr-event-common-components/section-title';

export const FrBoloDetailsTabRecipientsSection = () => {
    const { form: boloForm } = useIntegratedForm<BoloPanelFormType>();
    const metadata = useBoloPanelMetadata();

    const { dispatchAreaRecipients, subdivisionRecipients } = boloForm.watch();

    if (!metadata) {
        return null;
    }

    const getContent = (options: AttributeOption[] | DispatchAreaOption[]) => {
        return options.length ? options.map((o) => o.label).join(', ') : '--';
    };

    return (
        <VStack alignItems="flex-start" gap={2}>
            <SectionTitle title="Recipients" />
            <DataList direction="column">
                <DataItem dataKey="Dispatch Areas">{getContent(dispatchAreaRecipients)}</DataItem>
            </DataList>
            <DataList direction="column">
                <DataItem dataKey="Subdivisions">{getContent(subdivisionRecipients)}</DataItem>
            </DataList>
        </VStack>
    );
};
